import { LabelValueOptionModel } from '@/domain/models/onboarding/label-value-option-model'

export interface OnboardingSkillsRecommended {
  getStepRecommendSkillByAreas(): Promise<LabelValueOptionModel<number>[]>
}

export namespace OnboardingSkillsRecommended {
  export type StepRecommendSkillByAreas = {
    id: number
    name: string
    interestAreaId: number
  }

  export const KeyGetStepRecommendSkillsByAreas = 'onboarding-options-recommend-skills-by-areas'
}
